import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-36869aa2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "text-center font-bold",
  style: {
    "padding-top": "100px"
  }
};
const _hoisted_2 = {
  key: 1,
  style: {
    "margin": "0 10px 10px 10px",
    "padding-top": "65px"
  }
};
const _hoisted_3 = {
  style: {
    "padding-left": "10px"
  }
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  style: {
    "margin": "20px 5px 10px 5px",
    "padding": "10px"
  },
  class: "bg-white"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  key: 0,
  style: {
    "padding-top": "10px",
    "padding-left": "10px"
  }
};
const _hoisted_8 = {
  style: {
    "line-height": "24px",
    "color": "#333",
    "font-weight": "bold"
  }
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "line-height": "24px",
    "color": "#333",
    "font-weight": "bold"
  }
}, "知识点：", -1));
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = {
  class: "font-bold flex align-center justify-center",
  style: {
    "margin-top": "20px"
  }
};
const _hoisted_13 = ["disabled"];
const _hoisted_14 = ["disabled"];
import { onMounted, reactive, ref, computed } from "vue";
import { useStore } from "vuex";
import { questionList, questionSubmit } from "../../../api/index";
import { useRoute, useRouter } from "vue-router";
import problemItem from "./problemItem.vue";
import Title from "../../../components/title.vue";
import { ElMessage } from "element-plus";
export default {
  __name: 'practice',
  setup(__props) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const safeMes = computed(() => store.state.safeMes);
    const activeSentenceIndex = ref(-2);
    const questions = reactive({
      dataValue: []
    });
    const answerList = reactive({
      dataValue: []
    });
    const waiting = ref(true);
    const disabled = ref(false);
    const isSubmit = ref(false);
    const title = ref("");
    onMounted(() => {
      if (!safeMes.value.sign) store.commit("saveSafeMes");
      title.value = route.params.obj.title;
      getProblems();
    });
    const chooseSentence = index => {
      if (activeSentenceIndex.value == index) {
        return activeSentenceIndex.value = -2;
      }
      activeSentenceIndex.value = index;
    };
    const getProblems = () => {
      let obj = {
        ...route.params.obj,
        ...safeMes.value
      };
      questionList(encodeURIComponent(JSON.stringify(obj))).then(res => {
        let data = res.data;
        if (data.code) return store.commit("judgeCode", {
          code: data.code,
          msg: data.msg
        });
        questions.dataValue = data.data.questions;
        waiting.value = false;
        while (questions.dataValue.length != answerList.dataValue.length) {
          answerList.dataValue.push("");
        }
      }).catch(() => {
        waiting.value = false;
        ElMessage.error("获取题目失败");
      });
    };
    const getAns = data => {
      let item = {
        answer: data.ans,
        questionId: questions.dataValue[data.index].id
      };
      answerList.dataValue.splice(data.index, 1, item);
    };
    const backOrSubmit = () => {
      disabled.value = true;
      if (!questions.dataValue.length) router.go(-1);
      if (isSubmit.value) {
        store.commit("changeArticle", true);
        router.go(-1);
      } else {
        let index = answerList.dataValue.findIndex(v => v === "");
        if (index != -1) {
          return ElMessage.warning("请填写所有题目哦");
        }
        let obj = {
          ...safeMes.value,
          articleId: route.params.obj.articleId,
          readLogId: route.params.obj.readLogId,
          answers: answerList.dataValue
        };
        questionSubmit(encodeURIComponent(JSON.stringify(obj))).then(res => {
          let data = res.data;
          if (data.code) {
            return store.commit("judgeCode", {
              code: data.code,
              msg: data.msg
            });
          }
          ElMessage.success("提交成功");
          disabled.value = false;
          isSubmit.value = true;
        }).catch(() => {
          disabled.value = false;
          ElMessage.error("提交答案失败");
        });
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(Title), !questions.dataValue.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(waiting.value ? "题目获取中..." : "暂时没有题目哦!"), 1)) : _createCommentVNode("", true), questions.dataValue.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", {
        style: {
          "color": "#333",
          "margin-left": "4px"
        },
        class: _normalizeClass(["font-bold", activeSentenceIndex.value == -1 ? 'active' : '']),
        onClick: _cache[0] || (_cache[0] = $event => chooseSentence(-1)),
        innerHTML: title.value
      }, null, 10, _hoisted_4)])])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.dataValue, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
          style: {
            "padding": "20px",
            "font-size": "10px",
            "background-color": "#f7f7f7",
            "border": "1px solid #ddd",
            "line-height": "24px"
          },
          class: "font-bold",
          innerHTML: item.title
        }, null, 8, _hoisted_6), _createVNode(problemItem, {
          aProblem: [item.selectA, item.selectB, item.selectC, item.selectD],
          tag: item.id + '',
          index: index,
          onGetAns: getAns
        }, null, 8, ["aProblem", "tag", "index"]), isSubmit.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, " 您选择的答案： " + _toDisplayString(questions.dataValue[index]["select" + answerList.dataValue[index].answer]) + " 正确答案： ", 1), _createElementVNode("span", {
          style: _normalizeStyle([{
            "line-height": "24px",
            "color": "#333",
            "font-weight": "bold"
          }, questions.dataValue[index]['select' + answerList.dataValue[index].answer] == questions.dataValue[index].answer ? '' : 'color:red;'])
        }, _toDisplayString(questions.dataValue[index].answer), 5), _hoisted_9, _hoisted_10, _createElementVNode("span", {
          style: {
            "line-height": "24px",
            "font-weight": "bold"
          },
          innerHTML: questions.dataValue[index].explanation
        }, null, 8, _hoisted_11)])) : _createCommentVNode("", true)])]);
      }), 128)), _createElementVNode("div", _hoisted_12, [questions.dataValue.length ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: {
          "margin-bottom": "50px",
          "padding": "8px 14px",
          "border": "1px solid #d3d3d3",
          "border-radius": "4px"
        },
        class: "bg-white hover",
        onClick: backOrSubmit,
        disabled: disabled.value
      }, _toDisplayString(isSubmit.value ? "下一篇" : "提交"), 9, _hoisted_13)) : _createCommentVNode("", true), !questions.dataValue.length ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        style: {
          "margin-bottom": "50px",
          "padding": "8px 14px",
          "border": "1px solid #d3d3d3",
          "border-radius": "4px"
        },
        class: "bg-white hover",
        onClick: backOrSubmit,
        disabled: disabled.value
      }, " 返回 ", 8, _hoisted_14)) : _createCommentVNode("", true)])]);
    };
  }
};